// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_WY6","cls2":"LoswpTabsHero-cls2_5tR LoswpTabsHero-cls1_WY6"};